import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

/**
 * Service to create campaign
 * @param {object} data - object contains all required properties to create new campaign
 */
export const createCampaignService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/freespin/fast-game-create-campaign', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'Campaign created successfully'
  })
}

/**
 * Service to fetch all campaigns
 */
export const getAllCampaignsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/freespin/fast-game-campaign-list', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getFreeSpinReportService = (params = {}) => {
  return axiosInstance(METHOD_TYPES.get, 'freespin/free-spin-users', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

/**
 * Service to get campaign details
 */
export const getCampaignDetailService = (campaignId) => {
  return axiosInstance(METHOD_TYPES.get, '/freespin/campaign-detail', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: { campaignId }
  })
}

/**
 * Service to update campaign details
 */
export const updateCampaignDetailsService = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/freespin/update-campaign', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'Campaign updated successfully'
  })
}

/**
 * Service to update campaign status
 */
export const updateCampaignStatusService = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/freespin/update-campaign-status', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    successMessage: 'Campaign status updated successfully'
  })
}

/**
 * Service to revoke a free spin campaign for specific users
 */
export const revokeFreeSpinUserCampaignService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/freespin/fast-game-revoke-campaign-status', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'Free spin revoked successfully'
  })
}

export const getCampaignPlayersService = (params = {}) => {
  return axiosInstance(METHOD_TYPES.get, '/freespin/get-campaign-players', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}